import Service from '@/helpers/service'

export default {

    index(params) {
        return Service().get('office-location/index', {params});
    },
    create(params) {
        return Service().post('office-location/create', params, {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
        });
    },
    update(id, params) {
        return Service().post('office-location/update/'+id, params, {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
        });
    },
    delete(id) {
        return Service().post('office-location/delete/'+id);
    },
}
